import fetchApi from '../fetch-api'
import CompanyIO from '../company-io'

type CompanyByIdPropsT = {
  companyId: string
}

export const getCompanyById = (props: CompanyByIdPropsT) => {
  const { companyId } = props
  return {
    queryKey: ['COMPANY_DETAIL', companyId],
    queryFn: () =>
      fetchApi({
        service: 'core-service',
        headers:{method: 'GET'},
        pathname: `/company-detail?companyId=${companyId}`,
        codec: CompanyIO,
      }),
   
  }
}
